import { render } from "./cartExpertTable.vue?vue&type=template&id=b969b80a&scoped=true&ts=true"
import script from "./cartExpertTable.vue?vue&type=script&lang=ts"
export * from "./cartExpertTable.vue?vue&type=script&lang=ts"

import "./cartExpertTable.vue?vue&type=style&index=0&id=b969b80a&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b969b80a"]])

export default __exports__